/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Display_New_Folder_Success_ToastInputs */

const en_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Folder "${i?.name}" created successfully`)
};

const fr_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dossier "${i?.name}" cree avec succes`)
};

const de_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ordner "${i?.name}" erfolgreich erstellt`)
};

const it_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cartella "${i?.name}" creata correttamente`)
};

const ru_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Папка "${i?.name}" успешно создана.`)
};

const es_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carpeta "${i?.name}" creada correctamente`)
};

const zh_cn2_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文件夹“${i?.name}”已成功创建。`)
};

const ja_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」が正常に作成されました`)
};

const hi_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर "${i?.name}" सफलतापूर्वक बनाया गया`)
};

const pt_pt2_explorer_display_new_folder_success_toast = /** @type {(inputs: Explorer_Display_New_Folder_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasta "${i?.name}" criada com sucesso`)
};

/**
* | output |
* | --- |
* | "Folder \"{name}\" created successfully" |
*
* @param {Explorer_Display_New_Folder_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_success_toast = /** @type {((inputs: Explorer_Display_New_Folder_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_success_toast(inputs)
	if (locale === "de") return de_explorer_display_new_folder_success_toast(inputs)
	if (locale === "it") return it_explorer_display_new_folder_success_toast(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_success_toast(inputs)
	if (locale === "es") return es_explorer_display_new_folder_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_success_toast(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_success_toast(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_success_toast(inputs)
	return en_explorer_display_new_folder_success_toast(inputs)
});